module.exports = __webpack_public_path__ + "img/clothes-hanger.96ff2794.svg";